customElements.define(
  "autoscroll-slider",
  class extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth > 1024) {
        try {
          // Initialize navigation buttons
          const prev = this.querySelector("#prev");
          const next = this.querySelector("#next");

          if (!prev || !next) {
            console.error("Navigation buttons not found");
            return;
          }

          // Initialize Splide
          const splide = new Splide(this, {
            type: "loop",
            arrows: false,
            pagination: false,
            gap: "4px",
            perPage: 4,
            breakpoints: {
              640: {
                perPage: 1.25,
                gap: "2px",
                autoScroll: {
                  speed: 0.75,
                },
              },
            },
          });

          // Mount the Splide instance
          splide.mount(window.splide.Extensions);

          // Add navigation event listeners
          next.addEventListener("click", () => {
            splide.go("+1");
          });

          prev.addEventListener("click", () => {
            splide.go("-1");
          });
        } catch (error) {
          console.error("Error initializing slider:", error);
        }
      } else {
        // Remove Splide classes for mobile
        this.classList.remove("splide");

        // Find and remove track class
        const track = this.querySelector(".splide__track");
        if (track) {
          track.classList.remove("splide__track");
        }

        // Find and remove list class
        const list = this.querySelector(".splide__list");
        if (list) {
          list.classList.remove("splide__list");
        }

        // Find and remove all slide classes
        const slides = this.querySelectorAll(".splide__slide");
        slides.forEach((slide) => {
          slide.classList.remove("splide__slide");
        });

        // Hide navigation buttons
        const controls = this.querySelector(".controls");
        if (controls) {
          controls.style.display = "none";
        }
      }

      // Add resize listener to handle screen size changes
      window.addEventListener("resize", () => {
        const isMobile = window.innerWidth <= 1024;
        const hasSlider = this.classList.contains("splide");

        // If mobile and has slider classes, remove them
        if (isMobile && hasSlider) {
          location.reload();
        }
        // If desktop and doesn't have slider classes, reload to initialize slider
        else if (!isMobile && !hasSlider) {
          location.reload();
        }
      });
    }
  }
);
